/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.ApiResponse,
  userChangeRole: (params: vp.UserChangeRoleRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostUserChangeRole: ApiHook = ({ api }) => {
  const [shouldUserChangeRole, setShouldUserChangeRole] = useState(false);
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [params, setParams] = useState<vp.UserChangeRoleRequest>({
    PartnerUserName: '',
    Role: '',
  });
  const [response, setResponse] = useState<vp.ApiResponse>({
    Success: false,
    ErrorMessage: '',
  });

  useEffect(() => {
    if (!shouldUserChangeRole) return () => {};

    const ChangeUserRole = async () => {
      setDataFetchingInfo(true, 'changing user role', 'fullScreen');
      const res = await api.postUserChangeRole(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldUserChangeRole) void ChangeUserRole();
    setShouldUserChangeRole(false);
    return () => {
      source.cancel();
    };
  }, [shouldUserChangeRole]);

  return [
    response,
    (_params: vp.UserChangeRoleRequest) => {
      setParams(_params);
      setShouldUserChangeRole(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
      });
      setShouldUserChangeRole(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostUserChangeRole);
